import React from "react";
import Layoute from "../components/layoute";
import fetch from "unfetch";
import {
  Alert,
  Upload,
  Input,
  Select,
  Card,
  Col,
  Row,
  Button,
  Icon,
  Divider,
  Badge,
} from "antd";
const Option = Select.Option;
const OptGroup = Select.OptGroup;

export default class extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: "",
      fileList: [],
      recipients: [],
      modules: {
        toolbar: [
          [{ size: ["normal", "large", "huge"] }],
          ["bold", "italic", "underline"],
          [{ align: [] }],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["link", "image"],
        ],
      },
    };
    if (typeof window !== "undefined") {
      this.quill = require("react-quill");
    }
    this.handleChange = this.handleChange.bind(this);
    this.beforeUpload = this.beforeUpload.bind(this);
    this.onRemove = this.onRemove.bind(this);
    this.newEmail = this.newEmail.bind(this);
  }

  componentDidMount() {
    fetch("/api/user", {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": localStorage.getItem("x-access-token"),
      },
    })
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          users: data.users,
          filterData: data.users,
          groups: data.groups,
        });
      });
  }

  startUpload() {
    this.setState({
      loading: true,
    });
    const formData = new FormData();
    this.state.fileList.forEach((file) => {
      formData.append("files[]", file);
    });
    formData.append("text", this.state.text);
    formData.append("recipients", this.state.recipients);
    formData.append("object", this.state.object);

    fetch("/api/company/emailing", {
      credentials: "include",
      method: "POST",
      headers: {
        "x-access-token": localStorage.getItem("x-access-token"),
      },
      body: formData,
    })
      .then((response) =>
        response.json().then((data) => ({
          ok: response.ok,
          data,
        }))
      )
      .then(({ ok, data }) => {
        this.setState({
          sent: true,
          err: data.message || data.err,
          success: ok && data.success,
          loading: false,
        });
      })
      .catch((err) => {
        this.setState({
          sent: true,
          err: err.message || "Impossible de contacter le service d envoi.",
          success: false,
          loading: false,
        });
      });
  }

  onRemove(file) {
    const index = this.state.fileList.indexOf(file);
    const newFileList = this.state.fileList.slice();
    newFileList.splice(index, 1);
    this.setState({
      fileList: newFileList,
    });
    return {
      fileList: newFileList,
    };
  }

  beforeUpload(file) {
    this.setState({
      fileList: [...this.state.fileList, file],
    });
    return false;
  }

  newEmail() {
    this.setState({
      fileList: [],
      object: "",
      tex: "",
      recipients: "",
      sent: false,
    });
  }

  handleChange(key, value) {
    if (
      key == "recipients" &&
      value.length > 0 &&
      value.join(" ").indexOf("@") == -1 &&
      value.join(" ").indexOf("group-") == -1
    ) {
      return false;
    } else {
      this.setState(
        {
          [key]: value,
        },
        () => {
          this.setState({
            valid:
              this.state.text &&
              this.state.text.trim() !== "<p><br></p>" &&
              this.state.object &&
              this.state.object.trim() !== "" &&
              this.state.recipients &&
              this.state.recipients.length > 0
                ? true
                : false,
          });
        }
      );
    }
  }

  handleFilter(val, option) {
    return option.props.filter.toLowerCase().indexOf(val.toLowerCase()) >= 0;
  }

  render() {
    const ReactQuill = this.quill;
    return (
      <React.Fragment>
        <h5>Emailing</h5>
        <p>
          Envoi d'email en masse à une selection de membres/adhérents de
          l'association
        </p>
        <Divider />
        <div>
          <div
            style={{ marginTop: "10px", marginBottom: "5px" }}
            className="custom-input"
          >
            <span className="required">*</span>
            Objet
            <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
              L'objet du message qui sera envoyé
            </div>
          </div>
          <Input
            value={this.state.object}
            onChange={(e) => this.handleChange("object", e.target.value)}
          />
        </div>
        <div>
          <div
            style={{ marginTop: "10px", marginBottom: "5px" }}
            className="custom-input"
          >
            Pièce jointe
            <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
              Les fichiers à joindre à l'email
            </div>
          </div>
          <Upload
            onRemove={(file) => this.onRemove(file)}
            fileList={this.state.fileList}
            beforeUpload={(file) => this.beforeUpload(file)}
            name="logo"
          >
            <Button>
              <Icon type="upload" /> Sélectionner les pièces jointes à ajouter
            </Button>
          </Upload>
        </div>
        <div>
          <div
            style={{ marginTop: "10px", marginBottom: "5px" }}
            className="custom-input"
          >
            <span className="required">*</span>
            Destinataires
            <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
              Pour les personnes appartenant à plusieurs groupes, l'email sera
              envoyé une seule fois
            </div>
          </div>
          <Select
            mode="tags"
            style={{ width: "100%" }}
            placeholder="Sélectionner un groupe ou des utilisateurs"
            value={this.state.recipients}
            onChange={(val) => this.handleChange("recipients", val)}
            filter
            optionFilterProp="filter"
            notFoundContent={null}
          >
            <OptGroup label="Année en cours">
              <Option filter="actif" value="group-actif" key={"group-actif"}>
                <b style={{ textTransform: "uppercase" }}>
                  <Badge status="success" /> Actifs
                </b>
              </Option>
              <Option filter="passif" value="group-passif" key={"group-passif"}>
                <b style={{ textTransform: "uppercase" }}>
                  <Badge status="warning" /> Passifs
                </b>
              </Option>
            </OptGroup>
            <OptGroup label="Groupes">
              {this.state.groups
                ? this.state.groups.map((g) => {
                    return (
                      <Option filter={g.slug} key={"group-" + g.slug}>
                        <b>
                          <Badge status="default" />
                          {g.title}
                        </b>
                      </Option>
                    );
                  })
                : ""}
            </OptGroup>
            <OptGroup label="Utilisateurs">
              {this.state.users
                ? this.state.users
                    .filter((u) => {
                      return u.email;
                    })
                    .map((u) => {
                      return (
                        <Option
                          filter={
                            u.company.name +
                            " " +
                            u.firstname +
                            " " +
                            u.lastname
                          }
                          key={u.email}
                        >
                          <b>
                            {u.company
                              ? u.company.name.trim().toUpperCase() + " - "
                              : ""}
                          </b>{" "}
                          {u.lastname ? u.lastname.toUpperCase() : ""}{" "}
                          {u.firstname ? u.firstname.trim().charAt(0) : ""}.
                        </Option>
                      );
                    })
                : ""}
            </OptGroup>
          </Select>
        </div>
        <div>
          <div
            style={{ marginTop: "10px", marginBottom: "5px" }}
            className="custom-input"
          >
            <span className="required">*</span>
            Contenu
            <div style={{ color: "#a8a8a8", fontSize: "12px" }}>
              Le contenu sera intégré automatiquement au gabarit comprenant le
              logo, la signature de l'association ...
            </div>
          </div>
          {ReactQuill ? (
            <ReactQuill
              value={this.state.text}
              modules={this.state.modules}
              onChange={(t) => this.handleChange("text", t)}
            />
          ) : (
            ""
          )}
        </div>

        {this.state.sent && this.state.success ? (
          <Alert
            style={{ marginTop: "10px" }}
            message="Emailing envoyé avec succès"
            description="Tous les emails ont été traités par le service d envoi."
            type="success"
            showIcon
          />
        ) : (
          ""
        )}
        {this.state.sent && !this.state.success ? (
          <Alert
            style={{ marginTop: "10px" }}
            message="Emailing non envoyé"
            description={
              this.state.err ||
              "Une erreur est survenue pendant l’envoi de l’emailing."
            }
            type="error"
            showIcon
          />
        ) : (
          ""
        )}
        {this.state.sent && this.state.success ? (
          <Button
            disabled={!this.state.valid}
            onClick={() => this.newEmail()}
            style={{ marginTop: "10px", width: "100%" }}
            size={"large"}
            type="primary"
            icon="inbox"
          >
            Envoyer un nouveau
          </Button>
        ) : (
          <Button
            loading={this.state.loading}
            disabled={!this.state.valid}
            onClick={() => this.startUpload()}
            style={{ marginTop: "10px", width: "100%" }}
            size={"large"}
            type="primary"
            icon="inbox"
          >
            Envoyer
          </Button>
        )}
        <div
          style={{ marginTop: "10px", fontSize: "12px", color: "#a8a8a8" }}
          className="custom-input"
        >
          Merci de remplir les champs indiqués par&nbsp;
          <span className="required">*</span>
        </div>
      </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./components/emailing.js